import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HubblePageRoutingModule } from './hubble-routing.module';

import { HubblePage } from './hubble.page';
import { DxDataGridModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { HubbleService } from './service/hubble.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		HubblePageRoutingModule,
		DxDataGridModule,
		DxLoadIndicatorModule,
	],
	declarations: [HubblePage],
	providers: [HubbleService],
})
export class HubblePageModule {}
